import React, { useState, useEffect } from 'react';
import {
  formatDateMonth,
  formatPrice,
  LoadingGrid,
} from '../../../../../_mexablock/helpers';
import { TableList } from '../../../../../_mexablock/helpers/components/TableList';
import 'flatpickr/dist/flatpickr.min.css';
import { MenuComponent } from '../../../../../_mexablock/assets/ts/components';
import { Filter } from './Filter';
import {
  getAllPaymentCommissions,
  downloadComprobantePagoPDF,
} from '../../../../service/pagos/pagados';

const View: React.FC = () => {
  const [reloadGrid, setReloadGrid] = useState<number>();
  const [loadingView, setloadingView] = useState(true);
  const [dataSends, setDataSends] = useState<any[]>([]);
  const [dateState, setDateState] = useState<string[]>([]);
  const [searchFilter, setSearchFilter] = useState<string>('');
  const [inputValue, setInputValue] = useState<string>('');
  const [initFilterValues, setInitFilterValues] = useState({
    init_date: '',
    end_date: '',
    filter: 0,
  });

  const fetchPost = async () => {
    try {
      const filters = {
        start_date: dateState[0],
        end_date: dateState[1],
        search: searchFilter,
      };
      const sends = await getAllPaymentCommissions(filters);
      if (sends?.rows) {
        setDataSends(sends.rows);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setloadingView(false);
    }
  };
  useEffect(() => {
    MenuComponent.reinitialization();
  }, [dataSends]);

  useEffect(() => {
    fetchPost();
  }, [dateState, searchFilter, reloadGrid]);

  const infoComprobante = async (idRegister: any) => {
    if (idRegister?.id) {
      try {
        await downloadComprobantePagoPDF(idRegister.id);
      } catch (err) {
        console.error('Error al descargar el comprobante:', err);
      }
    }
  };

  const getCommissionType = (operationType?: string) => {
    switch (operationType) {
      case 'PROVISION_CASH':
      case 'RECHARGE_CASH':
        return {
          text: 'Efectivo',
          badge: 'badge-light-success',
          sortValue: 'Efectivo',
        };

      case 'PROVISION_VIRTUAL':
      case 'RECHARGE_VIRTUAL':
        return {
          text: 'Saldo virtual',
          badge: 'badge-light-primary',
          sortValue: 'Saldo virtual',
        };

      default:
        return {
          text: 'N/A',
          badge: 'badge-light-info',
          sortValue: 'N/A',
        };
    }
  };
  const buildFullName = (...parts: (string | undefined | null)[]) =>
    parts.filter(Boolean).join(' ') || 'N/A';

  const columns: any = [
    {
      id: 'paid_at',
      name: <div className="fw-bolder text-muted me-5">Fecha pago</div>,
      selector: (row: any) => row.paid_at,
      cell: (row: any) =>
        row.paid_at ? formatDateMonth(row.paid_at) : 'Sin fecha',
      sortable: true,
    },
    {
      id: 'folio',
      name: <div className="fw-bolder text-muted me-5">Folio</div>,
      selector: (row: any) => row.folio,
      cell: (row: any) => row.folio || 'N/A',
      sortable: true,
    },
    {
      id: 'commission_type',
      name: <div className="fw-bolder text-muted me-5">Tipo comisión</div>,
      selector: (row: any) => {
        const operationType = row.items?.[0]?.commission?.operation_type;
        return getCommissionType(operationType).sortValue;
      },
      cell: (row: any) => {
        const operationType = row.items?.[0]?.commission?.operation_type;
        const { text, badge } = getCommissionType(operationType);

        return (
          <span
            className={`fw-normal badge ${badge} text-center d-inline-block`}
          >
            {text}
          </span>
        );
      },
      sortable: true,
    },
    {
      id: 'company_name',
      name: <div className="fw-bolder text-muted me-5">Cliente</div>,
      selector: (row: any) => row.company?.name,
      cell: (row: any) => row.company?.name || 'N/A',
      sortable: true,
    },
    {
      id: 'first_name',
      name: <div className="fw-bolder text-muted me-5">Titular cta.</div>,
      selector: (row: any) =>
        buildFullName(row?.first_name, row?.father_last_name),
      sortable: true,
    },
    {
      id: 'bank_name',
      name: <div className="fw-bolder text-muted me-5">Banco receptor</div>,
      selector: (row: any) => row.bank_name,
      cell: (row: any) => row.bank_name || 'N/A',
      sortable: true,
    },
    {
      id: 'total_amount',
      name: <div className="fw-bolder text-muted me-5">Pagado</div>,
      selector: (row: any) => Number(row.total_amount),
      cell: (row: any) => {
        const amount = Number(row.total_amount) || 0;
        return formatPrice(amount, 'es-MX', 'MXN', 2, 2);
      },
      sortable: true,
    },
    {
      id: 'acciones',
      name: <div className="fw-bolder text-muted me-5">Acciones</div>,
      cell: (row: any) => dropdownRender(row),
      sortable: false,
    },
  ];

  const dropdownRender = (row: any) => {
    const operationType = row.items?.[0]?.commission?.operation_type;
    const isDisabled = operationType === 'PROVISION_VIRTUAL';

    return (
      <>
        <div className="d-flex justify-content-end flex-shrink-0">
          <a
            data-kt-menu={!isDisabled ? 'true' : undefined}
            className={`btn btn-light btn-active-light-primary btn-sm ${
              isDisabled ? 'disabled' : ''
            }`}
            data-kt-menu-trigger={!isDisabled ? 'click' : undefined}
            data-kt-menu-placement="bottom-end"
            style={isDisabled ? { pointerEvents: 'none', opacity: 0.5 } : {}}
          >
            Acciones
            <span className="svg-icon svg-icon-5 m-0">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mh-50px"
              >
                <path
                  d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                  fill="currentColor"
                ></path>
              </svg>
            </span>
          </a>

          <div
            className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-4"
            data-kt-menu="true"
          >
            <div className="menu-item px-3">
              <a
                className="menu-link px-3"
                onClick={(e) => {
                  e.preventDefault();
                  infoComprobante(row);
                }}
              >
                Descargar comprobante
              </a>
            </div>

            {/* {row.status_id === 14 ? (
              <div className="menu-item px-3">
                <a
                  className="menu-link px-3"
                  href="#/"
                  onClick={() => {
                    console.log('Ver detalle');
                  }}
                >
                  Ver detalle
                </a>
              </div>
            ) : null} */}
          </div>
        </div>
      </>
    );
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\s/g, '');

    const regex = /^[a-zA-Z0-9áéíóúüñÁÉÍÓÚÜÑ.-]*$/;

    if (regex.test(value)) {
      setInputValue(value);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setSearchFilter(inputValue);
    }
  };

  setTimeout(() => {
    MenuComponent.reinitialization();
  }, 1000);

  const handleFilter = (values: any) => {
    setInitFilterValues(values);
    if (values) {
      setDateState([values.init_date, values.end_date]);
    }
  };

  const handleFilterClean = () => {
    setInitFilterValues({
      init_date: '',
      end_date: '',
      filter: 0,
    });
    setDateState([]);
  };

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              <Filter
                initFilterValues={initFilterValues}
                onCleanFilter={handleFilterClean}
                onSearchFilter={handleFilter}
              />
              <div className="card-toolbar">
                <div className="d-flex align-items-center position-relative me-4">
                  <span
                    className="position-absolute ms-3"
                    style={{ zIndex: 10 }}
                  >
                    <i className="bi bi-search fs-4 text-muted"></i>
                  </span>

                  <input
                    type="text"
                    className="form-control form-control-solid ps-9"
                    placeholder="Buscar"
                    maxLength={50}
                    onKeyDown={handleKeyDown}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={dataSends} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export { View };
